import { useWindowDimensions } from "react-native"

import { mobileMinWidth } from "$consts/Layout"

export function useIsMobile() {
  const width = useWindowDimensions().width
  return width < mobileMinWidth
}
